import React, { useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Controller, set } from "react-hook-form";
import { createFilterOptions } from "@mui/material";

//import { Box } from "@mui/system";
//import { styled } from "@mui/material/styles";

/* const useStyles = styled({
  inputRoot: {
    '&.MuiInput-root': {
      borderBottom: 'none',
      borderRadius: '10px'
    },
  },
}); */
/**
 * Este componenete esta hecho con Compatible con MUI 5.0 y es pensado en el use de react hook form
 * @param {*} param0
 * @returns
 */
const CustomAutoComplete = ({
  size = "medium",
  control,
  opciones,
  name,
  label,
  clearErrors,
  hashError = { value: false, message: "" },
  required = false,
  onChange = null,
  disabled = false,
  value = null,
  placeholder,
  multiple = false,
  filterSelectedOptions = true,
  optionsLimit = 100,
  noOptionsText = "Sin opciones",
  preventSubmitOnEnter = true,
}) => {
  //const classes = useStyles();
  const defaultFilterOptions = createFilterOptions();
  const [currentOptions, setCurrentOptions] = useState(opciones);
  const currentValue = value ?? (multiple ? [] : null);
  const handleOnChange = (event, newValue) => {
    clearErrors(name);
    if (onChange) {
      onChange(newValue);
    }
  };

  const getValueSelected = () => {
    if (currentValue) {
      if (multiple) {
        return currentValue;
      } else {
        if (currentValue.id) {
          return opciones.find((x) => x.id === currentValue.id) ?? null;
        }
        return null;
      }
    } else {
      return multiple ? [] : null;
    }
  };

  const filterOptions = (options, state) => {
    let result = defaultFilterOptions(options, state).slice(0, optionsLimit);
    return result;
  };

  const handleOnKeyDown = (event) => {
    if (preventSubmitOnEnter && event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Controller
      name={name}
      id={name}
      control={control}
      rules={{ required: required }}
      render={() => (
        <Autocomplete
          //className={{ inputRoot: { backgroundColor:"red"} }}
          onKeyDown={handleOnKeyDown}
          size={size}
          multiple={multiple}
          id={name}
          options={opciones}
          isOptionEqualToValue={(option, val) =>
            option &&
            val &&
            option?.id === val?.id &&
            option?.label === val?.label
          }
          value={getValueSelected()}
          onChange={handleOnChange}
          disabled={disabled}
          filterSelectedOptions={filterSelectedOptions}
          disablePortal={true}
          clearText="Limpiar"
          openText="Abrir"
          closeText="Cerrar"
          noOptionsText={noOptionsText}
          filterOptions={filterOptions}
          ListboxProps={{ style: { maxHeight: "200px" } }}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              {option.label}
            </li>
          )}
          
         
          renderInput={(params) => (
          <TextField
              type="text"
              variant="standard"
              id={name}
              error={hashError.value}
              helperText={hashError.message}
              {...params}
              //label={label}
              name={name}
              placeholder={placeholder ?? ''}
              inputProps={{
                ...params.inputProps,
                sx:{marginLeft: "0.8rem", minHeight:'32px',fontFamily:"Montserrat"},
              }}
              style={{background:'#00657d33',borderRadius:'10px'}}
              autoComplete="off"
              
            /> 
          )}
        />
      )}
    />
  );
};

export default CustomAutoComplete;
